<template>
  <!-- RQ "Internal Notes" card: loads its own list (detail page + data sheet page) -->
  <div class="rqCard">
    <div class="flex items-center gap-1 pb-[15px]">
      <div class="w-[8px] h-[8px] rounded-full bg-[#A084E8]" />
      <div class="w-[35px] h-[8px] rounded-full bg-[#A084E8]" />
      <p class="text-[18px] laptop:text-[20px] font-semibold pl-2 m-0 text-[#333333]">Internal Notes</p>
    </div>
    <div
      class="flex flex-col laptop:min-h-[267px] max-h-[400px] border-1 border-[#CCCCCC] rounded-[10px] bg-white p-[5px]">
      <ul class="flex-1 overflow-y-auto list-none m-0 p-[5px] flex flex-col gap-[10px]">
        <li v-for="note in notes" :key="(note.note_id || note.id) + '-' + note.created_at_timestamp">
          <!-- own notes grey, others white with a border -->
          <div class="rounded-[10px] p-[10px] text-[12px] text-[#333333] break-words"
            :class="note.user_id == myUserId ? 'bg-[#EFEFEF]' : 'bg-white border-1 border-[#EFEFEF]'">
            <!-- the note text is the main line; who / type is a small grey caption -->
            <p class="m-0 mb-[2px] text-[11px] text-[#999999]">{{ note.full_name }}<template v-if="note.type"> · {{ note.type
            }}</template></p>
            <p class="m-0 leading-[20px] text-[14px] whitespace-pre-line">{{ note.notes }}</p>
          </div>
          <p class="m-0 mt-[4px] px-[2px] text-[10px] text-[#999999]">{{ noteDate(note) }}</p>
        </li>
        <li v-if="!notes.length" class="py-4 text-center text-[12px] text-[#999999]">No notes yet</li>
      </ul>
      <div v-if="canWrite"
        class="flex items-center gap-2 h-[40px] mt-[5px] rounded-[10px] bg-white shadow-[0px_0px_20px_0px_#00000026] pl-[10px] pr-[5px]">
        <input v-model="newNote" type="text" maxlength="1000" placeholder="Write your Notes..."
          class="flex-1 min-w-0 border-0 outline-none bg-transparent text-[14px] text-[#333333] placeholder:text-[#666666]"
          @keyup.enter="addNote">
        <button type="button" :disabled="!newNote.trim() || busy" aria-label="Send note"
          class="w-[30px] h-[30px] flex-shrink-0 rounded-[6px] bg-[#EFEFEF] border-0 flex items-center justify-center disabled:opacity-50"
          @click="addNote">
          <i class="fa fa-paper-plane text-[#7695FF]" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { useToast } from "vue-toastification";
import { rqApi } from "../../services/rqApi";
const toast = useToast();

export default {
  props: {
    orderId: { type: [Number, String], required: true },
    // Android JobNotesFragment: writing only from Installation Pending until Closed
    canWrite: { type: Boolean, default: false },
  },
  data() {
    return {
      notes: [],
      newNote: "",
      busy: false,
      myUserId: JSON.parse(localStorage.getItem("user") || "{}")?.user?.user_id,
    };
  },
  watch: {
    orderId: { immediate: true, handler() { this.load(); } },
  },
  methods: {
    // same format as the other notes boxes; backend text when there is no timestamp
    noteDate(note) {
      return Number(note.created_at_timestamp) > 0 ? moment.unix(note.created_at_timestamp).format("MM/DD/YYYY hh:mm A") : note.created_at;
    },
    async load() {
      const res = await rqApi.notes(this.orderId);
      this.notes = res.ok && Array.isArray(res.body) ? res.body : [];
    },
    async addNote() {
      const text = this.newNote.trim();
      if (!text) return;
      this.busy = true;
      const res = await rqApi.addNote(this.orderId, text);
      this.busy = false;
      if (!res.ok) return toast.error(res.message || "Unable to add the note.");
      this.newNote = "";
      if (Array.isArray(res.body)) this.notes = res.body;
      else this.load();
    },
  },
};
</script>
